import { Spinner } from '@iwoca/orion';
import { Trans } from '@lingui/react/macro';
import clsx from 'clsx';
import { useNumberFormat } from 'hooks/useNumberFormat';
import { useGetRCFRepaymentSummary } from 'lendingApi/lendingApiHooks';
import styles from '../../SummaryCard.module.css';

type TProps = {
  offerId: string;
  maxAmount: number;
  offerIsSelected: boolean;
  offerNotSelected: boolean;
};

export const CommitmentFee = ({
  offerId,
  maxAmount,
  offerIsSelected,
  offerNotSelected,
}: TProps) => {
  const { formatCurrency } = useNumberFormat();
  const { data, isLoading } = useGetRCFRepaymentSummary(offerId, maxAmount);

  const commitmentFeeAmount = data?.data?.summary?.total_fees;

  if (isLoading) {
    return (
      <div className={styles.loaderContainer}>
        <Spinner dataTestId="spinner" />
      </div>
    );
  }

  return (
    <div
      className={clsx(styles.value, {
        [styles.selectedValue]: offerIsSelected,
        [styles.unselectedValue]: offerNotSelected,
      })}
    >
      {commitmentFeeAmount ? (
        <>
          {formatCurrency(commitmentFeeAmount)}{' '}
          <span className={styles.valueSubtext}>
            (<Trans>unique</Trans>)
          </span>
        </>
      ) : (
        '-'
      )}
    </div>
  );
};
